import { c as _c } from "react/compiler-runtime";
import { parseAsString, useQueryStates } from 'nuqs';
import { useCallback, useMemo, useTransition } from 'react';
const filtersConfig = {
  search: parseAsString.withDefault('').withOptions({
    shallow: false,
    history: 'replace',
    limitUrlUpdates: {
      method: 'debounce',
      timeMs: 300
    }
  })
} as const;
function useServicesFilters() {
  const $ = _c(13);
  const [filters, setFilters] = useQueryStates(filtersConfig);
  const [isSearchPending, startSearchTransition] = useTransition();
  const [isResetPending, startResetTransition] = useTransition();
  let t0;
  if ($[0] !== setFilters) {
    t0 = async (key, value, options) => setFilters(previous => ({
      [key]: typeof value === "function" ? value(previous[key]) : value
    }), options);
    $[0] = setFilters;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const setFilterValue = t0;
  let t1;
  if ($[2] !== setFilterValue) {
    t1 = (value_0, options_0) => {
      startSearchTransition(async () => {
        await setFilterValue("search", value_0, options_0);
      });
    };
    $[2] = setFilterValue;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const setSearch = t1;
  let t2;
  if ($[4] !== setFilters) {
    t2 = () => {
      startResetTransition(async () => {
        await setFilters({
          search: ""
        });
      });
    };
    $[4] = setFilters;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const onReset = t2;
  const isResetDisabled = isSearchPending || isResetPending || filters.search === "";
  let t3;
  if ($[6] !== filters.search || $[7] !== isResetDisabled || $[8] !== isResetPending || $[9] !== isSearchPending || $[10] !== onReset || $[11] !== setSearch) {
    t3 = {
      search: filters.search,
      isSearchPending,
      isResetPending,
      isResetDisabled,
      setSearch,
      onReset
    };
    $[6] = filters.search;
    $[7] = isResetDisabled;
    $[8] = isResetPending;
    $[9] = isSearchPending;
    $[10] = onReset;
    $[11] = setSearch;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  return t3;
}
export { useServicesFilters };